import { urlBinder } from "../../helper/url-binder";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { student } from "../../constants/apiUrl";
import { IStudentEarlyAlerts } from "../../models/student/studentGrades";

export default new (class StudentEarlyAlertsService {
  public getEarlyAlerts = async (
    id:string,
    count: number
  ): Promise<IApiResponse<IStudentEarlyAlerts>> => {
    try {
      let endPoint = urlBinder(student.STUDENT_EARLY_ALERTS,[`${id}/${count}`])
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IStudentEarlyAlerts>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IStudentEarlyAlerts>;
      } else {
        throw error;
      }
    }
  };
});